import { c as _c } from "react/compiler-runtime";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { MembersTable } from "@components/table/members/members-table";
import { fetchingGroupsFlagsSelector } from "@store/groups/groups-selector";
import { useAppSelector } from "@store/store-helper";
import { sortMembers } from "@utils/member-utils";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
/** Columns for group members table */
export const GROUP_MEMBERS_COLUMNS = ["name", "email", "status", "role", "joinedDate", "options"];

/** Columns for group members table when the workspace cannot assign managers */
const GROUP_VIEWERS_COLUMNS = GROUP_MEMBERS_COLUMNS.filter(column => column !== "role");

/**
 * Contains the Managers table of the group details
 */
export function GroupManagersTable(t0) {
  const $ = _c(20);
  const {
    group,
    members,
    companyId,
    isLoading: t1,
    bulkActionButtons,
    sortBy,
    setSortBy
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const {
    isFetchingGroups
  } = useAppSelector(fetchingGroupsFlagsSelector);
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  let t2;
  if ($[0] !== members || $[1] !== sortBy) {
    t2 = sortMembers(members, sortBy);
    $[0] = members;
    $[1] = sortBy;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const sortedMembers = t2;
  const columns = canAssignManagers ? GROUP_MEMBERS_COLUMNS : GROUP_VIEWERS_COLUMNS;
  let t3;
  if ($[3] !== columns) {
    t3 = columns.filter(_temp);
    $[3] = columns;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const defaultVisibleColumns = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["options"];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== defaultVisibleColumns) {
    t5 = {
      nonConfigurableColumns: t4,
      defaultVisibleColumns
    };
    $[6] = defaultVisibleColumns;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = isFetchingGroups || isLoading;
  let t7;
  if ($[8] !== bulkActionButtons || $[9] !== companyId || $[10] !== group || $[11] !== setSortBy || $[12] !== sortBy || $[13] !== sortedMembers || $[14] !== t6) {
    t7 = <MembersTable companyId={companyId} members={sortedMembers} tableSubject="group" isLoading={t6} group={group} bulkActionButtons={bulkActionButtons} sortBy={sortBy} setSortBy={setSortBy} />;
    $[8] = bulkActionButtons;
    $[9] = companyId;
    $[10] = group;
    $[11] = setSortBy;
    $[12] = sortBy;
    $[13] = sortedMembers;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== columns || $[17] !== t5 || $[18] !== t7) {
    t8 = <ColumnPreferencesProvider tableKey="group-members-table" columns={columns} options={t5}>{t7}</ColumnPreferencesProvider>;
    $[16] = columns;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp(column) {
  return column !== "options";
}